(async () => {
  if (typeof Symbol === 'undefined') {
    await import('es6-symbol/implement');
  }
})();
